module.exports = __webpack_public_path__ + "img/20190604161845104.facac028.png";